import { Center, Image, Text, VStack } from '@chakra-ui/react'
import ButtonComponent from './form/Button'
import { useNavigate } from 'react-router-dom';
import noPermissionImg from "assets/images/no_permission.png"
import { ROUTES } from "constants/routes";

export default function NoPermission() {
    const navigate = useNavigate();
    const backHome = () => {navigate(ROUTES.DASHBOARD.path)}

    return (
        <>
        <Center>
            <VStack spacing={4}>
                <Image 
                    src={noPermissionImg}
                    width="350px"
                    alt='No Permission'
                />
                <Text as='h3' fontSize='20px' fontWeight={700} color='black.900'>
                    Oops, Looks like you don&apos;t have permission to access this section.<br /> Please reach out to your administrator.
                </Text>
                <ButtonComponent
                    mt={10}
                    label='Take Me Home'
                    size='lg'
                    variant='solid'
                    onClick={backHome}
                />
            </VStack>
        </Center>
        </>
    )
}
